/** @module builtins/AudioContext */

if (typeof window !== 'undefined') {
    /**
     * A central place for window.AudioContext on all platforms.
     * @type {Function}
     */
    window.AudioContext ??= window.webkitAudioContext;
}
